export default [
  {
    path: '/v1',
    name: 'v1_experiments',
    component: () => import('@/views/v1/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/v1/experiment-details/:id',
    name: 'v1_experiment_details',
    component: () => import('@/views/v2/modules/skeleton/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true
        },
      ],
    },
  },
  {
    path: '/v1/experiment-details/:id',
    name: 'v1_experiment_details_1',
    component: () => import('@/views/v1/modules/skeleton/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true
        },
      ],
    },
  },
  {
    path: '/v1/experiment-details/:id',
    name: 'v1_experiment_details_2',
    component: () => import('@/views/v1/modules/skeleton/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true
        },
      ],
    },
  },
  {
    path: '/v1/experiment-details/:id',
    name: 'v1_experiment_details_3',
    component: () => import('@/views/v1/modules/skeleton/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true
        },
      ],
    },
  },
  {
    path: '/v1/blank1',
    name: 'v1_blank1',
    component: () => import('@/views/v1/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v1/blank2',
    name: 'v1_blank2',
    component: () => import('@/views/v1/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v1/blank3',
    name: 'v1_blank3',
    component: () => import('@/views/v1/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v1/blank4',
    name: 'v1_blank4',
    component: () => import('@/views/v1/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v1/blank5',
    name: 'v1_blank5',
    component: () => import('@/views/v1/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v1/blank6',
    name: 'v1_blank6',
    component: () => import('@/views/v1/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v1/blank7',
    name: 'v1_blank7',
    component: () => import('@/views/v1/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v1/blank8',
    name: 'v1_blank8',
    component: () => import('@/views/v1/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v1/profile',
    name: 'v1_pages_profile',
    component: () => import('@/views/v1/modules/skeleton/Profile.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'My Experiments',
          active: true,
        },
      ],
    },
  },
]
